<template>
  <div>22222 {{rawData}}</div>
</template>

<script>
export default {
  props:['rawData']
}
</script>

<style>

</style>